export const COMPARE_TYPE = {
  FDI_DOMESTIC: 'FDIDomestic',
  LARGE_SME: 'LargeSME',
  LISTED_LARGE: 'ListedLarge',
}

export const COMPARE_TYPE_DATA = [
  {
    label: 'companyAnalysis.industryAnalysis.FDI_DOMESTIC',
    value: COMPARE_TYPE.FDI_DOMESTIC,
    isI18n: true,
  },
  {
    label: 'companyAnalysis.industryAnalysis.LARGE_SME',
    value: COMPARE_TYPE.LARGE_SME,
    isI18n: true,
  },
  {
    label: 'companyAnalysis.industryAnalysis.LISTED_LARGE',
    value: COMPARE_TYPE.LISTED_LARGE,
    isI18n: true,
  },
]

export const KEY_DATA = {
  VALUE_1: 'value1',
  VALUE_2: 'value2',
  NET_REVENUE_GROWTH: 'rT0156',
  NET_PROFIT_MARGIN: 'rT2002',
  ROA: 'rT2003',
  TOTAL_DEBT_TO_TOTAL_EQUITY: 'rT0027',
  CURRENT_RATIO: 'rT0020',
}

export const MAP_TYPE_TITLE = {
  [COMPARE_TYPE.FDI_DOMESTIC]: {
    [KEY_DATA.VALUE_1]: 'companyAnalysis.industryAnalysis.FDI',
    [KEY_DATA.VALUE_2]: 'companyAnalysis.industryAnalysis.DOMESTIC',
  },
  [COMPARE_TYPE.LARGE_SME]: {
    [KEY_DATA.VALUE_1]: 'companyAnalysis.industryAnalysis.LARGE',
    [KEY_DATA.VALUE_2]: 'companyAnalysis.industryAnalysis.SME',
  },
  [COMPARE_TYPE.LISTED_LARGE]: {
    [KEY_DATA.VALUE_1]: 'companyAnalysis.industryAnalysis.LISTED',
    [KEY_DATA.VALUE_2]: 'companyAnalysis.industryAnalysis.LARGE_PRIVATE',
  },
}

export const MAP_KEY_TITLE = {
  FDI: 'companyAnalysis.industryAnalysis.FDI',
  Domestic: 'companyAnalysis.industryAnalysis.DOMESTIC',
  CompanySizeLarge: 'companyAnalysis.industryAnalysis.LARGE',
  CompanySizeSME: 'companyAnalysis.industryAnalysis.SME',
  Listed: 'companyAnalysis.industryAnalysis.LISTED',
  Large: 'companyAnalysis.industryAnalysis.LARGE_PRIVATE',
}

export const mapViewBy = {
  chart: {
    label: 'riskScaleAndInterpretation.chart',
    value: 'Chart',
    isI18n: true,
  },
  table: {
    label: 'riskScaleAndInterpretation.table',
    value: 'Table',
    isI18n: true,
  },
}
